import React from 'react';
import * as ga from 'react-ga';
import { getPurchaseButtonLabel } from '../../utils/products';
import { quickbuy } from '../../actions';
import './suggestion.less';
import { IReduxProps } from '../../actions/action-types';
import { IProduct } from '../../reducers/products-reducers';

const defaultNavigateUrl = 'https://store.faithlifetv.com';

export interface ISuggestion {
	url: string;
	productId: string;
	target: string;
	alt: string;
	image: string;
	title: string;
	layout: string;
	orientation: string;
}

interface ISuggestionProps extends IReduxProps {
	product?: IProduct;
	suggestion: ISuggestion;
}

interface ISuggestionState {
	canPurchase: boolean;
	navigateUrl: string;
	target: string;
	isSubscription: boolean;
	buttonText?: string;
	buttonType: string;
	clicks: number;
}

export class Suggestion extends React.Component<ISuggestionProps, ISuggestionState> {
	componentWillMount() {
		const { product: prod, suggestion: sug } = this.props;
		const canPurchase = !!(prod && !prod.ownsProduct && prod.cartUrl && prod.price);
		const navigateUrl = prod && prod.storeUrl ? prod.storeUrl : sug && sug.url ? sug.url : defaultNavigateUrl;
		const target = sug && sug.target ? sug.target : '_self';
		this.setState({ canPurchase, navigateUrl, target });

		if (prod) {
			this.setState({
				canPurchase,
				buttonText: getPurchaseButtonLabel(prod),
				buttonType: 'sug-button',
				clicks: 0,
				isSubscription: !!prod.subscriptionPeriodKind,
			});
		}
	}

	_handleButtonClick = () => {
		const { dispatch, product } = this.props;
		const purchaseUrl = product && product.purchaseUrl;
		const productId = product && product.productId;

		if (purchaseUrl && productId) {
			const { buttonType, clicks, isSubscription } = this.state;
			const storeUrl = product && product.storeUrl;

			if (clicks === 0) {
				const newButtonText = isSubscription ? 'Confirm Subscription' : 'Confirm Purchase';
				ga.outboundLink({ label: `Interest - ${storeUrl}` }, () => {});
				this.setState({
					clicks: clicks + 1,
					buttonText: newButtonText,
					buttonType: buttonType.concat(' sug-button-confirm'),
				});
			} else if (clicks === 1) {
				ga.outboundLink({ label: `Purchase - ${storeUrl}` }, function() {
					dispatch(quickbuy(productId, purchaseUrl));
				});
				this.setState({ clicks: clicks + 1 });
			}
		} else {
			this._navigateToStore(this.state.target, product && product.cartUrl);
		}
	};

	_navigateToStore(target, url) {
		ga.outboundLink({ label: url }, function() {
			if (target && target !== '_self') {
				window.open(url, target);
			} else {
				window.location.href = url;
			}
		});
	}

	render() {
		const { alt, image, title, layout, orientation } = this.props.suggestion;
		const { buttonText, buttonType, canPurchase, navigateUrl, target } = this.state;

		return layout && layout === 'full' ? (
			<div className="suggestion sug-container-full">
				<a target={target} title={title} href={navigateUrl} onClick={() => this._navigateToStore(target, navigateUrl)}>
					{canPurchase ? <div className="learn-more-tag">Learn more</div> : false}
					<img className={`${orientation || 'portrait'}-cover`} src={image} alt={alt || title} />
					{canPurchase ? false : <div className="title">{title}</div>}
				</a>
				{canPurchase && buttonText ? (
					// TODO: Fix this the next time the file is edited.
					// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
					<div className={buttonType} onClick={this._handleButtonClick}>
						{buttonText}
					</div>
				) : (
					false
				)}
			</div>
		) : (
			<div className="suggestion sug-container">
				{canPurchase && buttonText ? (
					// TODO: Fix this the next time the file is edited.
					// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
					<div className={buttonType} onClick={this._handleButtonClick}>
						{buttonText}
					</div>
				) : (
					false
				)}
				<a target={target} title={title} href={navigateUrl} onClick={() => this._navigateToStore(target, navigateUrl)}>
					{canPurchase ? <div className="learn-more-tag">Learn more</div> : false}
					<img src={image} alt={alt || title} />
					{canPurchase ? false : <div className="title">{title}</div>}
				</a>
			</div>
		);
	}
}
